module.exports = __webpack_public_path__ + "img/rw.5a0f8bca.svg";